// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../reason/clients/components/Labels.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/Components/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ClientPropertyMlsStatus = require("../common/Components/ClientPropertyMlsStatus.bs.js");
let SharedForSalePropertyStatus_property_graphql = require("../../__generated__/SharedForSalePropertyStatus_property_graphql.bs.js");

let convertFragment = SharedForSalePropertyStatus_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SharedForSalePropertyStatus_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SharedForSalePropertyStatus_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SharedForSalePropertyStatus_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SharedForSalePropertyStatus_property_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function SharedForSalePropertyStatus$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(SharedForSalePropertyStatus_property_graphql.node, convertFragment, props.property);
  let match = property.status;
  let tmp;
  switch (match.__typename) {
    case "ExpiredProperty" :
      tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {}),
          JsxRuntime.jsx(ClientPropertyMlsStatus.make, {
            property: property.fragmentRefs
          })
        ]
      });
      break;
    case "SoldProperty" :
      tmp = JsxRuntime.jsx(Labels.SoldLabel.make, {});
      break;
    case "UnderContractProperty" :
      tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {
        children: JsxRuntime.jsx(Labels.UnderContractLabel.make, {})
      });
      break;
    case "ActiveProperty" :
    case "__unselected" :
      tmp = JsxRuntime.jsx(ClientPropertyMlsStatus.make, {
        property: property.fragmentRefs
      });
      break;
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "flex gap-4"
  });
}

let WithoutErrorBoundary = {
  make: SharedForSalePropertyStatus$WithoutErrorBoundary
};

function SharedForSalePropertyStatus(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property status",
    children: JsxRuntime.jsx(SharedForSalePropertyStatus$WithoutErrorBoundary, {
      property: props.property
    })
  });
}

let make = SharedForSalePropertyStatus;

exports.Fragment = Fragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
